import { FormField } from './FormField';

export const EmailField = ({ name, title, tooltip }: EmailFieldProps) => {
  return (
    <FormField name={name} title={title} type="email" placeholder="nom@domaine.fr" tooltip={tooltip} />
  );
};

interface EmailFieldProps {
  name: string;
  title?: string;
  tooltip?: string;
}